import React, { useEffect, useState, useTransition } from 'react';
import { Page, Button, Icon, Link, Banner, FooterHelp, Pagination, BlockStack, Text, Card, InlineStack } from '@shopify/polaris';
import { Table } from 'antd';
import {
  AlertMinor, CircleInformationMajor, CircleTickOutlineMinor
} from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../Core';
import { getAmazonRegion } from '../../ProductLinkingsNew/components/utils/utils';
import TransferOrderSkeleton from '../skeleton/TransferOrderSkeleton';
import "../styles/Transfer.css";
import { useTranslation } from 'react-i18next';

interface Props extends DIProps {
  syncNecessaryInfo: () => void;
  syncConnectorInfo: () => void;
  necessaryDetails?: any;
  viewOnAmazon: (data: any) => string;
}

function TransferOrder(props: Props) {

  const sourceData = props?.redux?.current?.source;
  const targetData = props?.redux?.current?.target;
  const necessaryDetails = {
    'source': {
      'shopId': sourceData?._id, // shopify shop id
      'marketplace': sourceData?.marketplace // shopify
    },
    'target': {
      'shopId': targetData?._id, // amazon shop id
      'marketplace': targetData?.marketplace // amazon
    },
  }
  const [lineItemData, setlineItemData] = useState<any>()
  const [gridData, setgridData] = useState<any>()
  const columns = [
    {
      title: 'Product Title',
      dataIndex: 'title',
      key: 'title',
      width: '300px',
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
      width: '150px',
    },
    {
      title: 'ASIN',
      dataIndex: 'ASIN',
      key: 'ASIN',
      width: '150px',

    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: '100px',
    },
  ];

  const [orderCreated, setorderCreated] = useState(false)
  const [transLoading, settransLoading] = useState(false)
  const [loadTransferButton, setloadTransferButton] = useState(false)
  const { t } = useTranslation();

  useEffect(() => {
    renderLineItemData()
  }, [])

  function getSection(apiData: any) {
    let data: any = {};
    data = {
      ...necessaryDetails,
      'data': {
        'matched': "all",
        'user_id  ': apiData?.user_id,
      },
      filter: {
        'seller-sku': { '1': apiData?.sku }
      }
    }
    props.di.POST(`amazon/product/getAmazonListing`, data).then(val => {
      if (Object.keys(val?.response).length > 0) {

        if (Object.keys(val?.response).includes('closeMatchedProduct') && !Object.keys(val?.response).includes('matched')) {
          renderProductLinking(apiData, 'closedMatch')
        }
        if (!Object.keys(val?.response).includes('closeMatchedProduct') && !Object.keys(val?.response).includes('matched')) {
          renderProductLinking(apiData, 'linkingRequired')
        }
      } else {
        props.error(t('No product(s) found for SKU: ') + apiData?.sku);
      }
    })
  }

  function renderProductLinking(data: any, string: any) {
    props.history('../productlinkings', { state: { sku: data?.sku, from: "transferOrder", to: string, marketplace_reference_id: props?.location?.state?.marketplace_reference_id, cif_order_id: props?.location?.state?.cif_order_id } });
  }

  async function renderLineItemData() {
    settransLoading(true)
    setlineItemData(props?.location?.state)
    let items = props?.location?.state?.items;
    let temp: any = [];
    let skus: any = [];
    if (items == undefined && props?.location?.state?.marketplace_reference_id) {
      let obj: any = { activePage: '1', count: 10 };
      obj['filter[marketplace_reference_id][1]'] = props?.location?.state?.marketplace_reference_id;
      obj['filter[object_type][1]'] = "source_order";
      let response = await props.di.GET('connector/order/getAll', obj);
      if (response?.data && response?.data?.rows) {
        items = response?.data?.rows?.[0]?.['items']
      }
    }
    items?.forEach((ele: any, idx: number) => {
      ele['key'] = idx;
      ele['sku'] && skus.push(ele['sku'])
      ele['isLinked'] = ele?.['product_identifier'] ? true : false
      ele['title'] = ele?.['title'] ?? "_"
      ele['sku'] = ele?.['sku'] ?? "_"
      ele['ASIN'] = ele?.['ASIN'] ?? "_"
      ele['action'] = !ele?.['isLinked'] ? <Button
        id='failedOrder_tour_5'
        onClick={() => {
          getSection(ele)
        }}
        variant="primary">Link</Button> : <Button disabled icon={<Icon source={CircleTickOutlineMinor} tone="base" />}>Linked</Button>
      temp.push(ele)
    })
    let data: any = {};
    data = {
      ...necessaryDetails,
      'data': {
        'activePage': '1',
        'count': '50',
        'seller-sku': skus
      }
    }
    let tempRows: any = {}
    await props.di.POST(`amazon/product/getAmazonListing`, data).then(val => {
      if (val?.success) {
        if (val?.response?.length > 0) {
          val?.response?.forEach((ele: any) => {
            tempRows[ele['seller-sku']] = ele;
          })
          temp?.forEach((element: any, key: any) => {
            if (tempRows[element['sku']]) {
              temp[key]['isLinked'] = tempRows[element['sku']]['matched'] ?? false
              temp[key]['action'] = !tempRows[element['sku']]['matched'] ?
                <Button

                  id='failedOrder_tour_5'
                  onClick={() => {
                    getSection(element)
                  }}
                  variant="primary">Link</Button>
                : <Button disabled icon={<Icon source={CircleTickOutlineMinor} tone="base" />}>Linked</Button>
            }
          });
          setgridData(JSON.parse(JSON.stringify([...temp])))
          settransLoading(false)
        }
      } else {
        props.error(val?.message ?? (val?.response?.length <= 0 ? t("No products found") : t("Request unsuccessful")));
      }
      settransLoading(false)
    })
    setgridData(temp)
  }

  function handleNavigation() {
    props.history(`../failed-order/${props?.location?.state?.from}`);
  }

  const createFailedOrder = async () => {
    setloadTransferButton(true)
    let obj: any = {
      "source": { "marketplace": "shopify", "shopId": props?.redux?.current?.source?.['_id'] },
      "target": { "marketplace": "amazon", "shopId": props?.redux?.current?.target?.['_id'] },

      "target_shop_id": props?.redux?.current?.target?.['_id'],
      "target_marketplace": "amazon",
      "cif_order_id": props?.location?.state?.cif_order_id
    }
    if (props?.location.state?.cif_order_id && props?.location?.state?.cif_order_id != "") {
      let response = await props.di.POST('connector/order/createOrder', obj);
      setloadTransferButton(false)
      if (response?.success) {
        setorderCreated(true)
        props?.success("Order created successfully.");
      }
      else {
        if (response?.data) {
          if (response?.message && typeof response.message == 'string') {
            props.error(response?.message)
          }
          response?.data?.forEach((ele: any) => {
            if (ele?.['shop_id'] == props?.redux?.current?.source?.['_id']) {
              props?.error(ele?.['errors']?.[0]);
            }
          });
        } else {
          if (response?.message && typeof response.message == 'object' && response.message?.save) {
            Object.values(response.message.save).forEach((ele: any) => {
              ele.failed != undefined && ele.failed[0].reason != "undefined" && props?.error(ele.failed[0]?.reason ?? "Oops! Some error occured.")
            })
          } else {
            props?.error(typeof response?.message != "string" ? response.message : "Oops! Some error occured.")
          }
        }
      }
    }
    else {
      props?.error("Given order is not found")
    }
    setloadTransferButton(false)
  }

  function getAmazonUrl() {
    let urlObj: any = {};
    urlObj = getAmazonRegion(props?.redux?.current?.target?.warehouses?.[0]?.marketplace_id ?? "", "marketplace_id")
    let finalUrl = urlObj?.failed_order_url + "/orders-v3/order/" + lineItemData?.marketplace_reference_id;
    return finalUrl
  }

  return (
    <div className='card-box-shadow'>
      <Page
        title="Create Order"
        subtitle='You can easily create your active Amazon account’s order on Shopify by linking the Amazon product with a Shopify product on the basis of SKU, Barcode, or other details.'
        backAction={{ onAction: () => { handleNavigation() } }}
      >
        <div className='Custom-title'>
          <BlockStack gap="100">
            <Link target='_blank' url={getAmazonUrl()}>View On Amazon</Link>
            <Text as='p'>Order ID : {lineItemData?.marketplace_reference_id ?? "_"}</Text>
          </BlockStack>
        </div>
        <BlockStack gap="400">
          {orderCreated &&
            <div id='failedOrder_tour_11'>
              <Banner
                title="Order created successfully"
                children="All the products has been successfully linked and the order has been processed. "
                tone="success"
              />
            </div>
          }
          {
            !orderCreated &&
            <Card roundedAbove='sm'>
              <BlockStack gap="200">
                {!transLoading ? (
                  <Table
                    pagination={false}
                    size='middle'
                    dataSource={gridData}
                    columns={columns}
                    loading={transLoading}
                    scroll={{ x: 600 }}
                    className='Table_Wrapper'
                    id='failedOrder_tour_4'
                    footer={() => <InlineStack align="space-between" blockAlign="center" wrap={false} gap="200">
                      <div className='Custom-Stack_Item--fill'>
                        <InlineStack blockAlign="start" gap="100" wrap={false}>
                          <div>
                            <Icon source={AlertMinor} tone="base" />
                          </div>
                          <div className='Custom-Stack_Item--fill'>
                            <Text as='span' tone="subdued">This action can be completed after all the products have been successfully linked</Text>
                          </div>
                        </InlineStack>
                      </div>
                      <Button
                        id='failedOrder_tour_10'
                        disabled={!gridData?.every((e: any) => e?.isLinked)}
                        loading={loadTransferButton}
                        onClick={createFailedOrder}
                        variant="primary">Create Order</Button>
                    </InlineStack>}
                  />) : (<TransferOrderSkeleton />)
                }
                <InlineStack gap="400" align="center">
                  <Pagination
                    label={<div><Text as='span'>1 / {' '}</Text><Text as='span' tone="subdued">1</Text></div>}
                    hasPrevious
                    onPrevious={() => {
                    }}
                    hasNext
                    onNext={() => {
                    }}
                  />
                </InlineStack>
              </BlockStack>
            </Card>
          }
        </BlockStack>

        <FooterHelp>
          <InlineStack align="center" gap="100">
            <div>
              <Icon
                source={CircleInformationMajor}
                tone="info"
              />
            </div>Learn more about<Link target='_blank' url="https://support.cedcommerce.com/portal/en/kb/articles/overview-26-3-2024">
              CedCommerce Amazon Channel
            </Link>,<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
              Terms & Conditions
            </Link>and<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
              Data Privacy Rights
            </Link>. Need Help?<Link target='_blank'
              url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}>
              Get Support
            </Link>or<Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
              Book a Call
            </Link>
          </InlineStack>
        </FooterHelp>
      </Page></div>
  );
}

export default DI(TransferOrder);